<ng-container *ngIf="masterConfig; else skeleton">
  <div>
    <!-- Bills -->
    <div class="heading-tab">
      <h3 class="heading"><i nz-icon [nzType]="headingIco||'profile'"></i> {{masterConfig?.parentGridTitle | MMSTranslate}}
        <a *ngIf="!environment.production" nz-tooltip nzTooltipTitle="Meta Data Example"
          (click)="exampleConfigModal = true;"><i nz-icon nzType="info-circle" nzTheme="outline"></i></a>
          <span class="heading-desc"> {{(masterConfig?.parentGridDescription | MMSTranslate) || ''}}</span>
        <ng-container *ngTemplateOutlet="spellChecker; context: {phrase: masterConfig?.parentGridTitle}">
        </ng-container>
      </h3>

      <!-- <button nz-button nzType="primary" (click)="modalBill = true; OCRprocessBill()">
        View Bills/OCR
      </button> -->

      <button
        *ngIf="masterConfig?.canAdd && !masterConfig['parentRowFormMetaDataMap']['FORMARRAY']"
        nz-button nzType="primary" (click)="addRow()">
        {{'Add' | MMSTranslate}} {{masterConfig?.parentGridTitle}}

        <ng-container *ngTemplateOutlet="spellChecker; context: {phrase: masterConfig?.parentGridTitle}">
        </ng-container>
      </button>
    </div>
    <form [formGroup]="parentGridForm">
      <nz-table [nzData]="[1, 2]" [nzShowPagination]="false" [nzScroll]="{ x: '1200px' }" class="table-valign-top"
        [nzSize]="'default'">
        <thead>
          <tr>
            <th *ngIf="masterConfig['parentRowFormMetaDataMap']['FORMARRAY']" nzWidth="40px">
              <!--Leave empty-->
            </th>
            <th nzWidth="80px">{{'Sr No' | MMSTranslate}}.</th>
            <ng-container *ngFor="let parentFormField of masterConfig.parentRowFormMetaData">
              <th *ngIf="parentFormField.visibility" [nzWidth]="parentFormField.width">
                {{parentFormField.fieldName | MMSTranslate}} <ng-container
                  *ngTemplateOutlet="spellChecker; context: {phrase: parentFormField.fieldName}">
                </ng-container>
              </th>
            </ng-container>

            <th *ngIf="masterConfig?.canAdd" style="width: 120px;">{{'Actions' | MMSTranslate}}</th>
            <!-- <th style="width: 230px;">Details</th> -->
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="
              let parentFormItem of parentGridForm.get(masterConfig.parentFormArray)['controls'];
              let parentIndex = index">
            <!-- MAIN -->
            <tr [formGroup]="parentFormItem">
              <td *ngIf="masterConfig['parentRowFormMetaDataMap']['FORMARRAY']"
                [nzShowExpand]="!!parentFormItem.get(masterConfig['parentRowFormMetaDataMap']['FORMARRAY'].fieldKey).value.length > 0"
                [(nzExpand)]="bills[parentIndex]" nzWidth="40px">
              </td>
              <td data-dd="Number" class="text-a-center" nzWidth="40px">
                {{ parentIndex + 1 }}
              </td>
              <ng-container *ngFor="let parentFormField of masterConfig.parentRowFormMetaData">
                <td *ngIf="parentFormField.visibility && !parentFormField.isChildGrid"
                  [ngSwitch]="parentFormField.fieldType" [class.inputs-are-disabled]="parentFormField.disabled">
                  
                  <ng-container *ngSwitchCase="'SEARCHANDLINK'">
                    <a *ngIf="!parentFormItem.value.remarkCd" (click)="openSearchRemarkCodeModal(parentIndex)">Search and Add Investigator</a>
                    <a *ngIf="parentFormItem.value.remarkCd" 
                      nz-dropdown [nzDropdownMenu]="remarkCodeNumber"> {{ parentFormItem.value.remarkCd }} <i nz-icon nzType="down"></i></a>
                    <input type="hidden" [formControlName]="parentFormField.fieldKey" (ngModelChange)="
                                            fieldDataChangeHandler(
                                              parentFormField,
                                              parentFormField.fieldKey,
                                              parentFormItem.value,
                                              parentIndex
                                            )" />
                    <nz-dropdown-menu #remarkCodeNumber="nzDropdownMenu">
                      <ul nz-menu nzSelectable>
                        <li nz-menu-item (click)="openSearchRemarkCodeModal(parentIndex)">Change</li>
                        <li nz-menu-item (click)="unlinkRemarkCode(parentIndex)"><span nz-text nzType="danger">Remove</span></li>
                      </ul>
                    </nz-dropdown-menu>
                  </ng-container>

                  <ng-container *ngSwitchCase="'COMBO'">
                    <!-- <nz-select nzShowSearch [id]="parentFormField.fieldKey" [formControlName]="parentFormField.fieldKey"
                      (ngModelChange)="fieldDataChangeHandler(parentFormField, parentFormField.fieldKey, parentFormItem)"
                      [nzDisabled]="parentFormField.disabled" style="width: 100%">
                      <nz-option
                        *ngFor="let item of (lookup$[parentFormField.lookupCd] || []) as LookupList; trackBy:item?.lookupKey"
                        [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                    </nz-select> -->
                    <nz-select nzShowSearch nzAllowClear
                      [nzMode]="parentFormField.comboMode? parentFormField.comboMode : 'default'"
                      [id]="parentFormField.fieldKey" [formControlName]="parentFormField.fieldKey"
                      (ngModelChange)="fieldDataChangeHandler(parentFormField, parentFormField.fieldKey, parentFormItem.value, parentIndex)"
                      [nzDisabled]="parentFormField.disabled" style="width: 100%">
                      <ng-container
                        *ngIf="lookupValueListMap[parentFormField.fieldKey + '-' + parentIndex]; else asyncLookup">
                        <nz-option
                          *ngFor="let item of lookupValueListMap[parentFormField.fieldKey + '-' + parentIndex]; trackBy:item?.lookupKey"
                          [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                      </ng-container>
                      <ng-template #asyncLookup>
                        <nz-option
                          *ngFor="let item of (lookup$[parentFormField.lookupCd] | async) as LookupList; trackBy:item?.lookupKey"
                          [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                      </ng-template>
                    </nz-select>
                  </ng-container>
                  <ng-container *ngSwitchCase="'DATE'">
                    <nz-date-picker nzShowTime [id]="parentFormField.fieldKey"
                      [formControlName]="parentFormField.fieldKey"
                      (ngModelChange)="fieldDataChangeHandler(parentFormField, parentFormField.fieldKey, parentFormItem.value, parentIndex)"
                      [nzDisabled]="parentFormField.disabled"
                      [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR">
                    </nz-date-picker>
                  </ng-container>
                  <ng-container *ngSwitchCase="'INPUT'">
                    <input nz-input [formControlName]="parentFormField.fieldKey"
                      (ngModelChange)="fieldDataChangeHandler(parentFormField, parentFormField.fieldKey, parentFormItem.value, parentIndex)"
                      [readonly]="parentFormField.disabled" />
                  </ng-container>
                  <ng-container *ngSwitchCase="'NUMBERINPUT'">
                    <nz-input-number [formControlName]="parentFormField.fieldKey" [nzMin]="0" [nzStep]="1"
                      (ngModelChange)="fieldDataChangeHandler(parentFormField, parentFormField.fieldKey, parentFormItem.value, parentIndex)"
                      [nzDisabled]="parentFormField.disabled"></nz-input-number>
                  </ng-container>
                  <ng-container *ngSwitchCase="'CURRENCYINPUT'">
                    <input currencyMask type="text" [options]="currencyOptions" nz-input
                      [formControlName]="parentFormField.fieldKey"
                      (ngModelChange)="fieldDataChangeHandler(parentFormField, parentFormField.fieldKey, parentFormItem.value, parentIndex)"
                      [readonly]="parentFormField.disabled" />
                  </ng-container>
                  <ng-container *ngSwitchCase="'TEXTAREA'">
                    <textarea rows="2" [maxlength]="parentFormField.maxlength" nz-input
                      [formControlName]="parentFormField.fieldKey"></textarea>
                    <p style="font-size: xx-small;">
                      {{parentFormItem.value[parentFormField.fieldKey]? parentFormItem.value[parentFormField.fieldKey].length: 0}}{{parentFormField.maxlength? '/' + parentFormField.maxlength : null}}
                      Characters</p>
                  </ng-container>
                  <ng-container *ngSwitchCase="'CHECKBOX'">
                    <label nz-checkbox [formControlName]="parentFormField.fieldKey">
                    </label>
                  </ng-container>
                  <ng-container *ngSwitchCase="'TIME'">
                    <nz-time-picker [id]="parentFormField.fieldKey" [formControlName]="parentFormField.fieldKey"
                      (ngModelChange)="fieldDataChangeHandler(parentFormField, parentFormField.fieldKey, parentFormItem.value, parentIndex)"
                      [nzDisabled]="parentFormField.disabled" style="width:100%" [nzFormat]="'HH:mm'">
                    </nz-time-picker>
                  </ng-container>
                  <ng-container *ngSwitchCase="'DOCUMENT'">
                    <app-document-manager [mode]="'mini'" [requirementCd]="parentFormField.docConfig.requirementCd"
                      [heading]="parentFormField.fieldName" [headingType]="parentFormField.docConfig.headingType"
                      [requirements]="[]" [RequirementEntityGuid]="entityGuid">
                    </app-document-manager>
                  </ng-container>
                  <!-- <div *ngSwitchDefault> Unsupported Metadata.</div> -->

                </td>
              </ng-container>

              <td *ngIf="masterConfig?.canAdd">
                <a *ngIf="(!masterConfig['parentRowFormMetaDataMap']['FORMARRAY']) || (parentIndex != 0)"
                  (click)="removeRow(parentIndex) ;"> {{'Remove' | MMSTranslate}} </a>
              </td>
              <!-- <td data-dd="Details">
                <textarea nz-input cols="2" rows="2" placeholder="Remarks ..." [disabled]="true"></textarea>
              </td> -->
            </tr>

            <ng-container *ngIf="masterConfig['parentRowFormMetaDataMap']['FORMARRAY']">
              <!--CHILD -- CHANGE *ngIf LOGIC -->
              <tr [nzExpand]="bills[parentIndex]" style="background: #fff;">
                <td>
                  <!-- Leave empty -->
                </td>
                <td colspan="16">
                  <h5 class="d-b p-t-b-5">
                    {{masterConfig['parentRowFormMetaDataMap']['FORMARRAY']['childGridTitle'] | MMSTranslate}}
                    <ng-container
                      *ngTemplateOutlet="spellChecker; context: {phrase: masterConfig['parentRowFormMetaDataMap']['FORMARRAY']['childGridTitle']}">
                    </ng-container>
                  </h5>
                  <div class="bg-white nested-child-table">
                    <form [formGroup]="parentFormItem">
                      <nz-table #innerTable [nzData]="[0]" nzSize="small" [nzScroll]="{ x: '580px' }"
                        [nzShowPagination]="false">
                        <!-- CHILD TABLE HEADER -->
                        <thead>
                          <tr>
                            <ng-container
                              *ngFor="let childFormField of masterConfig['parentRowFormMetaDataMap']['FORMARRAY']['childGridMetaData']">
                              <th *ngIf="childFormField.visibility" [nzWidth]="childFormField.width">
                                {{childFormField.fieldName | MMSTranslate}} <ng-container
                                  *ngTemplateOutlet="spellChecker; context: {phrase: childFormField.fieldName}">
                                </ng-container>
                              </th>
                            </ng-container>
                            <!-- <th style="width: 120px;">Status</th> -->
                            <th style="width: 120px;">{{'Actions' | MMSTranslate}}</th>
                          </tr>
                        </thead>
        <tbody>
          <!-- CHILD TABLE DATA -->
          <ng-container *ngFor="
          let childFormItem of parentFormItem.get(masterConfig['parentRowFormMetaDataMap']['FORMARRAY'].fieldKey)['controls'];
          let childIndex = index
        ">
            <tr *ngIf="childFormItem" [formGroup]="childFormItem">
              <ng-container
                *ngFor="let childFormField of masterConfig['parentRowFormMetaDataMap']['FORMARRAY']['childGridMetaData']">
                <td *ngIf="childFormField.visibility" [ngSwitch]="childFormField.fieldType"
                  [class.inputs-are-disabled]="childFormField.disabled">
                  <ng-container *ngSwitchCase="'COMBO'">
                    <!-- <nz-select nzShowSearch [id]="childFormField.fieldKey" [formControlName]="childFormField.fieldKey"
                      (ngModelChange)="fieldDataChangeHandler(childFormField.fieldGenericMapping)"
                      [nzDisabled]="childFormField.disabled" style="width: 100%">
                      <nz-option
                        *ngFor="let item of (lookup$[childFormField.lookupCd] || []) as LookupList; trackBy:item?.lookupKey"
                        [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                    </nz-select> -->
                    <nz-select nzShowSearch nzAllowClear
                      [nzMode]="childFormField.comboMode? childFormField.comboMode : 'default'"
                      [id]="childFormField.fieldKey" [formControlName]="childFormField.fieldKey"
                      (ngModelChange)="fieldDataChangeHandler(childFormField, childFormField.fieldKey, childFormItem.value, parentIndex, childIndex)"
                      [nzDisabled]="childFormField.disabled" style="width: 100%">
                      <ng-container
                        *ngIf="lookupValueListMap[childFormField.fieldKey + '-' + parentIndex + childIndex]; else asyncLookup">
                        <nz-option
                          *ngFor="let item of lookupValueListMap[childFormField.fieldKey + '-' + parentIndex + childIndex]; trackBy:item?.lookupKey"
                          [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                      </ng-container>
                      <ng-template #asyncLookup>
                        <nz-option
                          *ngFor="let item of (lookup$[childFormField.lookupCd] | async) as LookupList; trackBy:item?.lookupKey"
                          [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                      </ng-template>
                    </nz-select>
                  </ng-container>
                  <ng-container *ngSwitchCase="'DATE'">
                    <nz-date-picker nzShowTime [id]="childFormField.fieldKey"
                      [formControlName]="childFormField.fieldKey"
                      (ngModelChange)="fieldDataChangeHandler(childFormField, childFormField.fieldKey, childFormItem.value, parentIndex, childIndex)"
                      [nzDisabled]="childFormField.disabled" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR">
                    </nz-date-picker>
                  </ng-container>
                  <ng-container *ngSwitchCase="'INPUT'">
                    <input nz-input [formControlName]="childFormField.fieldKey"
                      (ngModelChange)="fieldDataChangeHandler(childFormField, childFormField.fieldKey, childFormItem.value, parentIndex, childIndex)"
                      [readonly]="childFormField.disabled" />
                  </ng-container>
                  <ng-container *ngSwitchCase="'NUMBERINPUT'">
                    <nz-input-number [formControlName]="childFormField.fieldKey" [nzMin]="0" [nzStep]="1"
                      (ngModelChange)="fieldDataChangeHandler(childFormField, childFormField.fieldKey, childFormItem.value, parentIndex, childIndex)"
                      [nzDisabled]="childFormField.disabled"></nz-input-number>
                  </ng-container>
                  <ng-container *ngSwitchCase="'CURRENCYINPUT'">
                    <input currencyMask type="text" [options]="currencyOptions" nz-input
                      [formControlName]="childFormField.fieldKey"
                      (ngModelChange)="fieldDataChangeHandler(childFormField, childFormField.fieldKey, childFormItem.value, parentIndex, childIndex)"
                      [readonly]="childFormField.disabled" />
                  </ng-container>
                  <ng-container *ngSwitchCase="'TEXTAREA'">
                    <textarea rows="2" [maxlength]="childFormField.maxlength" nz-input
                      [formControlName]="childFormField.fieldKey"></textarea>
                    <p style="font-size: xx-small;">
                      {{childFormItem.value[childFormField.fieldKey]? childFormItem.value[childFormField.fieldKey].length: 0}}
                      {{childFormField.maxlength? '/' + childFormField.maxlength : null}}
                      Characters</p>
                  </ng-container>
                  <ng-container *ngSwitchCase="'TIME'">
                    <nz-time-picker [id]="childFormField.fieldKey" [formControlName]="childFormField.fieldKey"
                      (ngModelChange)="fieldDataChangeHandler(childFormField, childFormField.fieldKey, childFormItem.value, parentIndex, childIndex)"
                      [nzDisabled]="childFormField.disabled" style="width:100%" [nzFormat]="'HH:mm'">
                    </nz-time-picker>
                  </ng-container>
                  <ng-container *ngSwitchCase="'CHECKBOX'">
                    <label nz-checkbox [formControlName]="childFormField.fieldKey"
                      (ngModelChange)="fieldDataChangeHandler(childFormField, childFormField.fieldKey, childFormItem.value, parentIndex, childIndex)">
                    </label>
                  </ng-container>
                  <ng-container *ngSwitchCase="'DOCUMENT'">
                    <app-document-manager [mode]="'mini'" [requirementCd]="childFormField.docConfig.requirementCd"
                      [heading]="childFormField.fieldName" [headingType]="childFormField.docConfig.headingType"
                      [requirements]="[]" [RequirementEntityGuid]="entityGuid">
                    </app-document-manager>
                  </ng-container>
                </td>
              </ng-container>

              <td>
                <a (click)="removeChildRow(parentIndex, childIndex) ;"> {{'Remove' | MMSTranslate}} </a>
              </td>
            </tr>
          </ng-container>
          <app-generic-zero-ui
            [list]="parentFormItem.get(masterConfig['parentRowFormMetaDataMap']['FORMARRAY'].fieldKey)['controls']">
          </app-generic-zero-ui>
          <!--ADD ROW -->
          <tr *ngIf="masterConfig['parentRowFormMetaDataMap']['FORMARRAY'].canAdd" class="tr-add-row">
            <td colspan="24">
              <a (click)="addChildRow(parentIndex)">+ {{'Add New' | MMSTranslate}}
                {{masterConfig['parentRowFormMetaDataMap']['FORMARRAY'].childGridTitle | MMSTranslate}}</a>
              <ng-container
                *ngTemplateOutlet="spellChecker; context: {phrase: masterConfig['parentRowFormMetaDataMap']['FORMARRAY'].childGridTitle}">
              </ng-container>
            </td>
          </tr>
        </tbody>
      </nz-table><!-- childTable -->
    </form>
  </div>
  </td>
  </tr>
</ng-container>
</ng-container>
<app-generic-zero-ui [list]="parentGridForm.get(masterConfig.parentFormArray)['controls']">
</app-generic-zero-ui>
<!--ADD ROW -->
<tr *ngIf="masterConfig?.canAdd && masterConfig['parentRowFormMetaDataMap']['FORMARRAY']"
  class="tr-add-row">
  <td colspan="24">
    <a (click)="addRow()">+ {{'Add New' | MMSTranslate}} {{masterConfig?.parentGridTitle | MMSTranslate}}</a>
    <ng-container *ngTemplateOutlet="spellChecker; context: {phrase: masterConfig?.parentGridTitle}">
    </ng-container>
  </td>
</tr>
</tbody>
</nz-table><!-- parentTable -->
</form>
<!-- Space -->
<div class="spacer p-t-b-20"></div>

<!-- Bills SUB (NOW unused -- used nexted tables above) -- >
    <div class="heading-tab">
      <h3 class="heading"><i nz-icon nzType="profile"></i> Bill Details</h3>
      <button nz-button nzType="primary" (click)="modalBill=true;OCRprocessBill()">View Bills/OCR</button>
    </div>
   <!-- -->
</div>
<!-- enclosing div-->

</ng-container>
<ng-template #skeleton>
  <button *ngIf="!environment.production" nz-button nzType="primary" (click)="exampleConfigModal = true;">Meta Data
    Example</button>
  <nz-skeleton [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" [nzLoading]="true">
  </nz-skeleton>
</ng-template>

<ng-template let-phrase="phrase" #spellChecker>

  <span style="font-size: xx-small; color: red;">{{(phrase | spellCheck)}}</span>
</ng-template>


<nz-modal [(nzVisible)]="exampleConfigModal" nzTitle="Example Meta Data" nzWidth="50%"
  (nzOnCancel)="exampleConfigModal = !exampleConfigModal" (nzOnOk)="exampleConfigModal = !exampleConfigModal">

  <nz-divider nzText="Supported TargetAttribute Types" nzOrientation="left"></nz-divider>
  <pre>{{supportedTargetAttributeTypes | json}}</pre>

  <nz-divider nzText="Current Meta Data" nzOrientation="left"></nz-divider>
  <pre>{{masterConfig | json}}</pre>

  <nz-divider nzText="Meta Data Example" nzOrientation="left"></nz-divider>
  <pre>{{exampleConfig | json}}</pre>
</nz-modal>

<!-- Search Investigator -->
<nz-modal [(nzVisible)]="modSearchRemarkCode" nzTitle="Search / Add Investigator"
  (nzOnCancel)="modSearchRemarkCode=false" (nzOnOk)="modSearchRemarkCode=false" nzOkText="Select"
  nzWidth="75%">

  <ng-container *nzModalContent>

    <div style="max-width: 650px">
      <app-ui-search *ngIf="modSearchRemarkCode" [SearchCriteria]="CRITERIALOOKUP" [extraExternalParams]="extraExternalParams"
        (componentOutput)="fetchSearchResult($event)" searchURL="provider/doctor/search" itemsPerPage='100'>
      </app-ui-search>
    </div>
  
    <!-- List fetched -->
    <div class="search-results m-t-20">
      <!-- Show Result Tables -->
      <nz-skeleton [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" [nzLoading]="searchRemarkCodeLoading">
        <!--  Search Results -->
        <div>
          <nz-table *ngIf="remarkCodeFetchedFromServer && remarkCodeFetchedFromServer.length > 0" #remarkCodeSearchTable
            [nzData]="remarkCodeFetchedFromServer" [nzSize]="'middle'" [nzShowPagination]="true">
            <thead>
              <tr>
                <th scope="col" style="width: 100px;">Select</th>
                <th scope="col" style="width: 160px;"><span translate>Remark Code</span></th>
                <th scope="col" style="width: 160px;"><span translate>Type</span></th>
                <th scope="col" style="width: 160px;"><span translate>Description</span></th>
                <th scope="col" style="width: 160px;"><span translate>Category</span></th>
                <th scope="col" style="width: 160px;"><span translate>Status</span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of remarkCodeSearchTable.data">
                <td><label nz-checkbox nzValue="data" [(ngModel)]="data['selected']"
                    (ngModelChange)="onSelectRemarkCode(data)"></label></td>
                <td>{{ data.remarkCd }}</td>
                <td>{{ data.typeCd | technicalTranslate }}</td>
                <td>{{ data.shortDesc }}</td>
                <td>{{ data.categoryCd | technicalTranslate }}</td>
                <td>{{ data.statusCd | technicalTranslate }}</td>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </nz-skeleton>
    </div>

  </ng-container>
</nz-modal>